import { DateRangePickerLabelContext } from 'utils/createTimeSeriesChartConfig';
import { useMemo } from 'react';
import { IntlShape } from 'react-intl';
import { DateRange } from 'components/filter/input/DateRangePicker/types';
import { useAppStore } from 'hooks/state/useAppStore';

const getDateBasedLabel = (dateRange: DateRange | undefined, intl: IntlShape) =>
  dateRange?.from && dateRange?.to ? intl.formatDateTimeRange(new Date(dateRange.from), new Date(dateRange.to)) : '';

export function useDatePickerLabels() {
  const { dateRange } = useAppStore();

  const safeRangeLabel = (intl: IntlShape) =>
    dateRange.range.presetLabel && dateRange.range.presetValue !== 'custom'
      ? intl.formatMessage({ id: dateRange.range.presetLabel })
      : getDateBasedLabel(dateRange.range, intl);

  const safeComparisonLabel = (intl: IntlShape) =>
    dateRange.comparison?.presetLabel && dateRange.comparison?.presetValue !== 'custom'
      ? intl.formatMessage({ id: dateRange.comparison.presetLabel })
      : getDateBasedLabel(dateRange.comparison, intl);

  const safeComparisonLabelForMeasureCard = (intl: IntlShape) =>
    dateRange.comparison?.presetLabel && dateRange.comparison?.presetValue !== 'custom'
      ? intl.formatMessage({ id: `${dateRange.comparison.presetLabel}.measureCard` })
      : getDateBasedLabel(dateRange.comparison, intl);

  const labelContext = {
    dateRangeLabel: dateRange.range.presetValue !== 'custom' ? dateRange.range.presetLabel : null,
    comparisonRangeLabel: dateRange.comparison?.presetValue !== 'custom' ? dateRange.comparison?.presetLabel : null,
    translatedSafeDateRangeLabel: safeRangeLabel,
    translatedSafeComparisonRangeLabel: safeComparisonLabel,
    translatedMeasureCardComparisonLabel: safeComparisonLabelForMeasureCard,
  } as DateRangePickerLabelContext;

  return useMemo(() => labelContext, [dateRange]);
}
